// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from 'firebase/firestore'
import {getAuth,GoogleAuthProvider} from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCjCHhWXNzoBGrEAOi9R4MWbyniG-UWlcQ",
  authDomain: "mestore-39eca.firebaseapp.com",
  projectId: "mestore-39eca",
  storageBucket: "mestore-39eca.appspot.com",
  messagingSenderId: "747292430374",
  appId: "1:747292430374:web:427e051c19e6d76c0656e7",
  measurementId: "G-R1ZKVQ38NT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app)
export const auth = getAuth(app)
export const provider = new GoogleAuthProvider()